import type { UserInformation } from "../types.ts";

export const computeUserInformationStepProgress = (input: UserInformation) =>
  ((input.firstName.length > 0 ? 1 : 0) +
    (input.lastName.length > 0 ? 1 : 0) +
    ((input.phoneNumber.number?.length ?? 0) > 0 ? 1 : 0) +
    (input.teamSize !== null ? 1 : 0)) /
  4;
